<template>
  <div class="header-result">
    <span class="student-name">{{ studentName }}</span>
    <div class="system-info">
      <div class="system-info-block">
        <span class="title">Hệ thống chấm tự động</span>
        <div class="system-stats">
          <span class="stat">Kĩ năng: {{ questionAndAnswerInfo && questionAndAnswerInfo?.questions && questionAndAnswerInfo?.questions?.skill }}</span>
          <span class="stat">Số câu đúng: {{ questionAndAnswerInfo && questionAndAnswerInfo?.correct_count }}/{{ questionAndAnswerInfo && questionAndAnswerInfo?.total_questions }}</span>
          <span class="stat">Số điểm: {{ questionAndAnswerInfo && questionAndAnswerInfo?.score }}</span>
        </div>
      </div>
    </div>
    <div class="action-buttons">
      <button
          v-if="questionAndAnswerInfo && questionAndAnswerInfo?.questions && questionAndAnswerInfo?.questions?.skill === 'Reading'"
          type="button" class="btn btn-secondary"
          @click="handleBack"
      >
        Quay lại
      </button>
      <button type="button" class="btn btn-success" @click="handleChangeSkill">
        Kĩ năng tiếp
      </button>
    </div>
  </div>
</template>

<script>
import { LISTENING, READING, SPEAKING } from '@/common/courseTemplate.js'

export default {
  name: 'HeaderReadingListeningResult',
  props: {
    questionAndAnswerInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      studentName: ''
    }
  },
  created() {
    this.studentName = this.$route.query.name
  },
  methods: {
    handleChangeSkill() {
      switch (this.questionAndAnswerInfo?.questions?.skill) {
        case 'Listening':
          this.$emit('changeSkill', READING)
          break
        case 'Reading':
          this.$emit('changeSkill', SPEAKING)
          break
      }
    },
    handleBack() {
      this.$emit('changeSkill', LISTENING)
    }
  }
}
</script>

<style scoped>
.header-result {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  justify-content: space-between;
  margin: 10px;
}

@media (min-width: 768px) {
  .header-result {
    flex-direction: row;
    gap: 24px;
  }
}

.student-name {
  display: block;
  font-size: 20px;
  font-weight: bold;
  white-space: nowrap;
  min-width: 300px;
}

.system-info {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-weight: bold;
}

.system-info-block {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-right: 16px;
}

.title {
  font-size: 20px;
}

.system-stats {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}

@media (min-width: 768px) {
  .system-stats {
    flex-direction: row;
    gap: 40px;
  }
}

@media (min-width: 1024px) {
  .system-stats {
    gap: 144px;
  }
}

.stat {
  font-size: 14px;
  white-space: nowrap;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
  width: 100%;
}

@media (min-width: 768px) {
  .action-buttons {
    justify-content: flex-end;
  }
}
</style>
